// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4dc19e0","455":"2a595674"}[chunkId] + ".chunk.js";
};